import React from 'react';
import moment from 'moment';

import { IDiscountCalculated } from 'interfaces/interfaces';
import {
    DiscountType, LoanApplication
} from 'generated/graphql';
import { hasComissionDiscount, hasInterestRateDiscount, hasGracePeriodDiscount } from 'utils/discount-utils';
import alertIcon from 'assets/svg/stay-alert.svg';
import trashIcon from 'assets/svg/trash.svg';

type CouponInputProps = {
    placeholder?: string,
    value: string,
    couponError: boolean,
    minimumInterestError: boolean;
    showCouponResponseCard: boolean,
    loanApplication: LoanApplication,
    discounts: DiscountType[],
    calculatedDiscounts: IDiscountCalculated,
    id?: string,
    onCloseInputButton(): void,
    onCloseCouponCardButton(): void,
    onChange(value: string): void,
    applyCoupon(value: string): void,
}

const CouponInput: React.FC<CouponInputProps> = (props: CouponInputProps) => {
    const {
        placeholder, onChange, value, onCloseInputButton, onCloseCouponCardButton,
        applyCoupon, couponError, minimumInterestError, showCouponResponseCard,
        calculatedDiscounts, discounts, loanApplication, id
    } = props;

    const classes = ["coupon-input-text"];
    const inputClasses = ["coupon-input"];

    let errorMessage = '';

    if (couponError) {
        inputClasses.push('coupon-error')
        errorMessage = 'código inválido. veja se você inseriu o código correto.'
    }
    if (minimumInterestError) {
        inputClasses.push('coupon-error')
        errorMessage = 'desculpe, não aplicamos descontos para taxas abaixo de 1,99% ao mês'
    }

    if (showCouponResponseCard) {
        return <CouponApplied
            value={value}
            onCloseCouponCardButton={onCloseCouponCardButton}
            loanApplication={loanApplication}
            discounts={discounts}
            calculatedDiscounts={calculatedDiscounts} />
    }

    const onSubmit = (event) => {
        event.preventDefault();
        applyCoupon(value)
    }

    return (
        <div className="coupon-input-container">
            <div className="coupon-insertion-container">
                <form className={inputClasses.join(' ')} onSubmit={onSubmit}>
                    <input
                        placeholder={placeholder}
                        className={classes.join(' ')}
                        onChange={(event) => onChange(event.target.value)}
                        value={value}
                        id={id || ""}
                    />

                    <Button
                        className="internal-button"
                        onClick={() => applyCoupon(value)}
                    >aplicar</Button>
                </form>

                <Button
                    className="external-button"
                    onClick={onCloseInputButton}
                >fechar</Button>
            </div>

            {errorMessage && <span className="coupon-error-message">{errorMessage}</span>}
        </div>
    );
}

const Button = ({ onClick, className, children }) => (
    <div className="button-container">
        <button className={`${className} primary-text`} type="button" onClick={onClick}>
            {children}
        </button>
    </div>
)

const CouponApplied: React.FC<{
    value: string,
    loanApplication: LoanApplication,
    discounts: DiscountType[],
    calculatedDiscounts: IDiscountCalculated,
    onCloseCouponCardButton(): void
}> = ({
    value,
    onCloseCouponCardButton,
    loanApplication,
    discounts,
    calculatedDiscounts }) => {
        const couponTextSetter = () => {
            if (discounts.length > 1) {
                return <>
                    descontos aplicados
            </>
            } else if (hasComissionDiscount(discounts, loanApplication)) {
                return <>
                    desconto na tarifa de cadastro
            </>
            } else if (hasInterestRateDiscount(discounts, loanApplication)) {
                return <>
                    taxa de juros de {Number(calculatedDiscounts.calculatedInterestRate).toFixed(2)}% ao mês
            </>
            } else if (hasGracePeriodDiscount(discounts, loanApplication)) {
                return <>
                    primeira parcela em {moment(calculatedDiscounts.calculatedPaymentDay).format("DD/MM")}
                </>
            } else {
                return null
            }
        }

        return (
            <div className="coupon-input-container">
                <div className="coupon-response-container">
                    <img
                        className="icon horizontal-margins" src={alertIcon}
                    />
                    <div className="coupon-response-text">
                        <span className="coupon-success">
                            "{value}" aplicado
                    </span>
                        <span className="text-center">
                            {couponTextSetter()}
                        </span>
                    </div>
                    <button className="coupon-response-button" onClick={onCloseCouponCardButton}>
                        <img
                            className="icon" src={trashIcon}
                        />
                    </button>
                </div>
            </div>
        )
    };


export default CouponInput;
